import {lazy} from 'react';

export const HeaderButtonLazy = lazy(() => import(/* webpackChunkName: "headerButton" */ '.'));
